import { Download, Visibility } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../contexts/Snackbar";
import { FILE_DOWNLOAD } from "../../enums/ApiPaths";
import { APPOINTEMENT_DETAILS } from "../../enums/UrlPaths";
import useEntityTranslation from "../../hooks/useEntityTranslation";
import api from "../../utils/api/authApi";
import { trimText } from "../../utils/Functions";
import { isFileViewable } from "../display/fileViewer/FileViewerUtils";
const trimLength = 15;

export default function FileTableRow({ data, index, onView, isViewLoading }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [downloading, setDownloading] = React.useState(false);
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const serviceTranslation = useEntityTranslation(data?.appointment?.priceList);
  const categoryTranslation = useEntityTranslation(data?.documentCategory);
  const isViewable = isFileViewable(data.fileDetails.name);

  function handleViewAppointment(id) {
    navigate(APPOINTEMENT_DETAILS + id);
  }

  async function handleFileDownload(fileId, name) {
    try {
      if (!fileId) return;
      setDownloading(true);
      const response = await api.get(`${FILE_DOWNLOAD}${fileId}`, {
        responseType: "blob",
      });

      let fileName = name;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      handleSnackbar("error", error);
    } finally {
      setDownloading(false);
    }
  }
  return (
    <TableRow
      key={index}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell>
        <Tooltip title={data.fileDetails.name}>
          {trimText(data.fileDetails.name, trimLength)}
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        <Tooltip title={categoryTranslation}>
          {trimText(categoryTranslation, trimLength)}
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        {String(data.fileDetails.name).toUpperCase().split(".")[1]}
      </TableCell>
      <TableCell align="center">
        {String(data.fileDetails.uploadDate)}
      </TableCell>
      <TableCell align="center">
        {serviceTranslation ? 
          <Tooltip title={serviceTranslation}>
            {trimText(serviceTranslation, trimLength)}
          </Tooltip> 
          : t("NoData")
        }
      </TableCell>
      <TableCell align="center">
        {data.appointment ? 
          <Button
            size="small"
            variant="text"
            onClick={() => handleViewAppointment(data.appointment.id)}
          >
            {t("View")}
          </Button> 
        : t("NoData")}        
      </TableCell>
      <TableCell align="center">
        {downloading || isViewLoading ? (
          <CircularProgress size="30px" />
        ) : (
          <Stack direction="row" justifyContent="center">
            <Tooltip title={t(isViewable ? "View" : "PreviewNotAvailable")}>
              <span>
                <IconButton
                  disabled={!isViewable}
                  onClick={onView}
                >
                  <Visibility />
                </IconButton>
              </span>
            </Tooltip>
            <IconButton
              title={t("Download")}
              onClick={() =>
                handleFileDownload(data.fileDetails.id, data.fileDetails.name)
              }
            >
              <Download />
            </IconButton>
          </Stack>
        )}
      </TableCell>
    </TableRow>
  );
}
